import { SeatOutlineIcon } from './SeatOutlineIcon';

/**
 * author: Google
 * id 2F61EAD1-DF0E-4E90-8260-875EA5221F35
 * name seat-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat-outline.svg
 * tags
 * - Home Automation 
 */
export const EventSeatOutlineIcon = SeatOutlineIcon;
export default EventSeatOutlineIcon